// Static TSX context snippets for AI CSS generation. Keep concise and representative.
// These snippets help the AI understand structure and common selectors per section.

export const ELEMENT_TSX_CONTEXT: Record<string, { tsx: string; selectors?: string[]; notes?: string }> = {
  hero: {
    tsx: `
<section data-element="hero" className="hero-grid">
  {/* variant: grid | scroller | swiper | swiper_full */}
  <a className="hero-card big">
    <div className="bg" />
    <div className="meta">
      <div className="tag">Aktuality</div>
      <h2 className="title">Nadpis</h2>
    </div>
  </a>
  <a className="hero-card" />
  <a className="hero-card" />
</section>
`.trim(),
    selectors: ['.hero-grid', '.hero-card', '.bg', '.meta', '.tag', '.title'],
    notes: 'Full-bleed variants may use negative margins and viewport width tricks.'
  },
  matches: {
    tsx: `
<section data-element="matches" className="next-match">
  <button className="nav prev" />
  <div className="team">
    <img className="logo" />
    <div>Domácí</div>
  </div>
  <div className="countdown">Začátek zápasu</div>
  <div className="team">
    <img className="logo" />
    <div>Hosté</div>
  </div>
  <button className="nav next" />
</section>
`.trim(),
    selectors: ['.next-match', '.team', '.logo', '.countdown', '.nav.prev', '.nav.next'],
    notes: 'Center content, strong contrast on countdown. Keep buttons accessible.'
  },
  'matches-slider': {
    tsx: `
<section data-element="matches-slider" className="matches-slider">
  <div className="section-head">
    <h3>Zápasy</h3>
    <a className="see-all" />
  </div>
  <div className="matches-grid">
    <div className="matches-track">
      <div className="match-card">
        <div className="match-meta" />
        <div className="teams">
          <div className="team"><img /><div className="name" /></div>
          <div className="score"><span className="home" /><span className="sep" /><span className="away" /></div>
          <div className="team"><img /><div className="name" /></div>
        </div>
      </div>
    </div>
    <div className="matches-tabs"><button className="active" /></div>
  </div>
</section>
`.trim(),
    selectors: ['.matches-slider', '.section-head', '.see-all', '.matches-grid', '.matches-track', '.match-card', '.match-meta', '.teams', '.team', '.score', '.matches-tabs'],
    notes: 'Horizontal scrolling track with cards; consider responsive card widths and gaps.'
  },
  news: {
    tsx: `
<section data-element="news" className="news-list">
  <div className="section-head"><h3>Další aktuality</h3></div>
  <div className="blog-list">
    <a className="card">
      <div className="thumb" />
      <div><h4>Title</h4><div className="excerpt" /></div>
    </a>
  </div>
  <div><a className="btn">Zobrazit všechny aktuality</a></div>
</section>
`.trim(),
    selectors: ['.news-list', '.section-head', '.blog-list', '.card', '.thumb', '.btn'],
  },
  table: {
    tsx: `
<section data-element="table" className="standings">
  <div className="table-card">
    <div className="section-head">
      <h3>Tabulky</h3>
      <a className="see-all" />
    </div>
    <div className="standings-table-wrapper">
      <table className="standings-table-compact">
        <thead><tr><th>#</th><th>Tým</th><th>Z</th><th>V</th><th>R</th><th>P</th><th className="hide-mobile">Skóre</th><th>Body</th></tr></thead>
        <tbody><tr><td>#1</td><td><img />Tým</td><td>…</td></tr></tbody>
      </table>
    </div>
  </div>
</section>
`.trim(),
    selectors: ['.standings', '.table-card', '.section-head', '.standings-table-wrapper', '.standings-table-compact', '.see-all'],
    notes: 'Compact table; mind overflow-x on small screens.'
  },
  sponsors: {
    tsx: `
<section data-element="sponsors" className="sponsors">
  <div className="section-head"><h3>Sponzoři</h3></div>
  <div className="sponsors-grid"><a className="sponsor-tile"><img /></a></div>
</section>
`.trim(),
    selectors: ['.sponsors', '.section-head', '.sponsors-grid', '.sponsor-tile'],
  },
};
